import {
  INavigateToPageConfig,
  navigateTo,
  isAppInstalled,
  getCurrentInstance,
  provisionApp,
  refreshInstance,
  appDefIds,
  showToast,
  ToastConfig,
  RemoveToast,
} from '@wix/business-manager-api';

const provisionAppAndRefreshInstance = async () => {
  await provisionApp(appDefIds.consentPolicyBanner);
  await refreshInstance(appDefIds.consentPolicyBanner);
};

export interface BusinessManagerService {
  navigateTo(config: INavigateToPageConfig): void;
  isAppInstalled(appDefId: string): boolean;
  getCurrentInstance(appDefId: string): string;
  provisionConsentPolicyApp(): Promise<void>;
  showToast(toastConfig: ToastConfig): { remove: RemoveToast };
}

export const businessManagerService: BusinessManagerService = {
  navigateTo,
  isAppInstalled,
  getCurrentInstance,
  provisionConsentPolicyApp: provisionAppAndRefreshInstance,
  showToast,
};
